import React from 'react';
import { Link } from 'react-router-dom';
import S from './checkout.module.css'
import A from '../App.module.css'
import icon from '../shared/img/icon-128.png'

function CheckoutDone( props ) {
  const { status } = props;
  let state = 'Error!';
  let message = (
    <div>
      <p>An unknown error occurred during checkout.</p>
      <p>
        Please
        <Link to="/">login</Link>
        {' '}
        to check your subscription status
      </p>
    </div>
  );
  switch ( status ) {
    case 'success':
      state = 'Success!'
      message = (
        <div>
          <p>Subscription checkout completed successfully.</p>
          <p>You are now subscribed to Script Keeper.</p>
        </div>
      );
      break;
    case 'canceled':
      state = 'Canceled.'
      message = (
        <div>
          <p>Subscription checkout has been canceled.</p>
          <p>You are not yet subscribed to Script Keeper.</p>
        </div>
      );
      break;
    case 'error':
      break;
    default:
      break;
  }
  return (
    <div className={A.container}>
      <div className={A.centerContainer}>
        <div className={S.container}>
          <div className={S.titleContainer}>
            <img height="40px" src={icon} alt="Script Keeper" />
            <h1>Script Keeper Checkout</h1>
          </div>
          <h2>{state}</h2>
          {message}
          <p><a href="https://rxscriptkeeper.com">rxscriptkeeper.com</a></p>
        </div>
      </div>
    </div>
  );
}

export default CheckoutDone;
